<template>
  <NodePressRelease
    v-if="node && node.__typename === 'NodePressRelease'"
    v-bind="node"
  />
  <div v-else />
</template>

<script lang="ts" setup>
definePageMeta({
  path: '/medienmitteilung/:slug(.*)*',
  languageMapping: {
    fr: '/communiques-de-presse/:slug(.*)*',
    it: '/comunicati-stampa/:slug(.*)*',
  },
  drupalRoute: true,
})

const { entity: node } = await useDrupalRouteQuery('nodePressRelease')

useRouteCache((c) => c.setCacheable().setMaxAge(600))
await renderPageDependencies()
</script>

<script lang="ts">
export default {
  name: 'PagePressReleaseSlug',
}
</script>
